import {
  IGetStepStaticDataResponse,
  TProductDetailsStaticDataDto,
  TUserDetailsStaticDataDto
} from "../types";
import { ESignupStep } from "features/common";

interface IMockStepStaticDataMap {
  [ESignupStep.UserDetails]: TUserDetailsStaticDataDto;
  [ESignupStep.CompanyDetails]?: any; // Replace with appropriate type
  [ESignupStep.ProductsDetails]: TProductDetailsStaticDataDto;
  [ESignupStep.Checkout]?: any; // Replace with appropriate type
  [ESignupStep.SignupReason]?: any; // Replace with appropriate type
  [ESignupStep.Billing]?: any; // Replace with appropriate type
  [ESignupStep.Relations]?: any; // Replace with appropriate type
  [ESignupStep.OptOut]?: any; // Replace with appropriate type
}

const mockUserDetailsStaticData: TUserDetailsStaticDataDto = {
  brand: "cl"
};

const mockProductDetailsStaticData: TProductDetailsStaticDataDto = {
  brand: "cl"
};

const MOCK_STEP_STATIC_DATA: IMockStepStaticDataMap = {
  [ESignupStep.UserDetails]: mockUserDetailsStaticData,
  [ESignupStep.ProductsDetails]: mockProductDetailsStaticData
};

export function getMockStepStaticData<T>(step = ESignupStep.UserDetails): T {
  return MOCK_STEP_STATIC_DATA[step];
}

export function getMockStepStaticDataResponse<T = TUserDetailsStaticDataDto>(
  step = ESignupStep.UserDetails
): IGetStepStaticDataResponse<T> {
  return {
    result: {
      stepNumber: step,
      stepData: getMockStepStaticData<T>(step)
    },
    isSuccess: true,
    message: `Static data for step ${step} retrieved successfully.`,
    validationIssues: null
  };
}
